export enum SidebarEnum{
    desktopLarge = 0,
    desktopSmall = 1,
    mobileExpanded = 2,
    mobileCollapsed = 3,
}
